import script from "./AddPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPatient.vue?vue&type=script&setup=true&lang=js"

import "./AddPatient.vue?vue&type=style&index=0&id=718d851c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-718d851c"]])

export default __exports__